/*
participantIds: array of strings (participants ids)
subjectType: string (subject type, 'referral' or 'case')
subjectId: string (subject id)
Returns a string that is "participantId1,participantId2,subjectType,subjectId"
*/
const generateUniqueName = _ref => {
  let {
    participantIds,
    subjectType,
    subjectId
  } = _ref;
  return "".concat(participantIds.join(","), ",").concat(subjectType, ",").concat(subjectId);
};
export default generateUniqueName;
//# sourceMappingURL=generateUniqueName.js.map